import { useWatch, type Control, type FieldValues } from 'react-hook-form';
import type { FormCustomRenderer } from '@packages/form-engine/types/renderer';
import { Typography } from '@packages/ui/primitives';

export const CUSTOM_REPORT_RENAME_FORM_SCHEMA_ID =
  'wealthlane://forms/custom-report-rename' as const;

export const CUSTOM_REPORT_RENAME_REMOTE_ERROR_RENDERER_KEY =
  'custom-report-rename-remote-error';

function CustomReportRenameRemoteError({ control }: { control: Control<FieldValues> }) {
  const remoteError = useWatch({ control, name: 'reportNameRemoteError' });
  const message =
    typeof remoteError === 'string' && remoteError.trim() !== '' ? remoteError.trim() : '';

  if (message === '') {
    return null;
  }

  return (
    <Typography
      variant='body-s'
      semanticId='customReportRenameRemoteError'
      className='report-error text-red-600'
      role='alert'
    >
      {message}
    </Typography>
  );
}

export const customReportRenameRemoteErrorRenderer: FormCustomRenderer =
  function CustomReportRenameRemoteErrorRenderer({ control }) {
    if (control == null) return null;
    return <CustomReportRenameRemoteError control={control as Control<FieldValues>} />;
  };

export const customReportRenameFormCustomRenderers: Record<string, FormCustomRenderer> = {
  [CUSTOM_REPORT_RENAME_REMOTE_ERROR_RENDERER_KEY]: customReportRenameRemoteErrorRenderer,
};

export function customRenderersForCustomReportRenameFormSchemaId(
  schemaId: string,
): Record<string, FormCustomRenderer> | undefined {
  if (schemaId === CUSTOM_REPORT_RENAME_FORM_SCHEMA_ID) {
    return customReportRenameFormCustomRenderers;
  }
  return undefined;
}
